import { Pagination } from "@shopify/polaris";
import styled from "styled-components";
import { useCustomerList } from "../../context/CustomerListContext";
import { customerListActions } from "../../context/customerListReducer";

const PaginationContainer = styled.div`
  & > div {
    & > nav {
      > div {
        display: flex;
        justify-content: space-between;

        & .Polaris-ButtonGroup__Item:last-child {
          .Polaris-Button {
            border-radius: 0.25rem 0 0 0.25rem;
          }
        }

        & .Polaris-ButtonGroup__Item:last-child {
          .Polaris-Button {
            border-radius: 0 0.25rem 0.25rem 0;
          }
        }
      }
    }
  }
`;

export const CustomerTablePagination = () => {
  const { state, dispatch } = useCustomerList();
  const totalCustomers = state.customers.length;

  const lastPageIndex = state.totalPages > 0 ? state.totalPages - 1 : 0;

  const handleNext = () => {
    dispatch(customerListActions.setPageNumber(state.pageNumber + 1));
  };

  const handlePrevious = () => {
    if (state.pageNumber > 0) {
      dispatch(customerListActions.setPageNumber(state.pageNumber - 1));
    }
  };

  return (
    <PaginationContainer>
      <div className="polaris-pagination-wrapper">
        <Pagination
          hasNext={state.totalPages === 0 ? totalCustomers === state.pageSize : state.pageNumber < lastPageIndex}
          hasPrevious={state.pageNumber > 0}
          onNext={handleNext}
          onPrevious={handlePrevious}
        />
      </div>
    </PaginationContainer>
  );
};
